import { useCallback } from 'react';
import { selectWarnOnSkipAreYouSureNumbersV2 } from 'features/premium/selectors';
import { selectFeatureFlag, selectFeatureFlags } from 'reducers/selectors';
import { useAppStore } from 'store/hooks';
import { Amplitude } from 'utils';
import { useLoginStackNavigation } from 'utils/types/navigationV6';
import checkFeatureFlag from 'utils/featureFlags';
import { useMarginBottom } from 'hooks/useMarginBottom';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import useIsTablet from 'hooks/useIsTablet';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { rem } from 'design-system';
import { HEIGHT } from 'design-system/Button';
import { OnboardingHowFreeTrialWorksWarningModal } from '../components/OnboardingHowFreeTrialWorksWarningModal';
import { useNavigateToLoggedInFromPremium } from './useNavigateToLoggedInFromPremium';
const useWarnOnSkip = () => {
    const store = useAppStore();
    const goNext = useNavigateToLoggedInFromPremium();
    const navigation = useLoginStackNavigation();
    const containerStyles = useMarginBottom('marginBottom');
    const isTablet = useIsTablet();
    const { top, bottom } = useSafeAreaInsets();
    const { height } = useAppFrameDimensions();
    const onSkip = useCallback(({ shouldSeePremiumTrialScreen, selectedTier, onDismiss, onConfirm, }) => {
        const handleConfirm = () => {
            if (onConfirm) {
                onConfirm();
                return;
            }
            const state = store.getState();
            if (selectFeatureFlag(state, 'premium_free_welcome_screen_2').value) {
                navigation.navigateDeprecated('OnboardingPremiumFreeWelcomeScreen');
            }
            else {
                goNext({
                    skippingPremium: true,
                    skippingPremiumBeforeChooseBank: checkFeatureFlag(state.utils.featureFlags, 'ab_paywall_before_and_after_choose_bank') && !state.signInNavigation.premiumScreenSkippedBeforeChooseBank,
                });
            }
            Amplitude.logEvent('EmmaPro.skipTop');
        };
        const warnOnSkipWithUserDeck = selectWarnOnSkipAreYouSureNumbersV2(store.getState());
        const warnOnSkipWithNumbers = !warnOnSkipWithUserDeck &&
            checkFeatureFlag(selectFeatureFlags(store.getState()), 'warn_on_skip_are_you_sure_numbers');
        OnboardingHowFreeTrialWorksWarningModal.show(selectedTier, shouldSeePremiumTrialScreen, containerStyles, handleConfirm, onDismiss, !warnOnSkipWithNumbers && !warnOnSkipWithUserDeck, isTablet ? height * 0.7 : height - top - bottom - rem(128) - 2 * HEIGHT, warnOnSkipWithNumbers, warnOnSkipWithUserDeck);
    }, [bottom, containerStyles, goNext, height, isTablet, top]);
    return onSkip;
};
export default useWarnOnSkip;
